import { Datagrid, TextField } from 'react-admin'
import { usePageTitle } from 'shared/components/PageTitle/PageTitle'

import { getUserFullName } from '../../helpers/utils'
import { CustomReferenceField } from '../Common/CustomReferenceFields'
import CTList from '../List'

const ReferralList = (props: any) => {
  usePageTitle('Referrals')

  return (
    <CTList bulkActionButtons={false} {...props}>
      <Datagrid optimized rowClick="show">
        <CustomReferenceField
          source="referral_code.referrer"
          baseUrl="/users"
          representationFunction={getUserFullName}
          label="Referrer"
        />
        <CustomReferenceField
          source="referree"
          baseUrl="/users"
          representationFunction={getUserFullName}
          label="Referee"
        />
        <TextField source="source" label="Referral Source" />
        <TextField source="referral_code.human_id" label="Referral Code" />
        <TextField source="status" label="Referral Status" />
      </Datagrid>
    </CTList>
  )
}
export default ReferralList
